import React from 'react';

const SultanBadge: React.FC = () => {
  return (
    <span title="Mode Sultan Aktif" className="ml-2 text-xl text-yellow-500 animate-pulse">👑</span>
  );
};

export default SultanBadge;
